import { TopBar } from '@/layouts/TopBar';
import { JButton } from '@atoms/JButton';
import FormStepperHeader from '@atoms/FormStepperHeader';
import { useTranslation } from 'react-i18next';
import { FormContainerStyled } from './establishment-form.styled';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';
import EstabilshmentFormProps from '@establishment/models/establishment-form-props';
import useEstablishmentMutation from '@establishment/hooks/useEstablishmentMutation';
import EstablishmentFormDetails from '@establishment/components/EstablishmentFormDetails';
import EstablishmentFormAddress from '@establishment/components/EstablishmentFormAddress';
import EstablishmentFormVideo from '@establishment/components/EstablishmentFormVideo';
import { Stack, Typography } from '@mui/material';
import useJDialog from '@/hooks/useJDialog';

const EstablishmentForm = ({ mode }: EstabilshmentFormProps) => {
  const { t } = useTranslation();
  const { showJDialog } = useJDialog();
  const { stepIndex, setMode, isDirty, setStepIndex } =
    useEstablishmentMutation();
  const navigation = useNavigate();
  const openCancelDialog = useCallback((): void => {
    if (isDirty) showJDialog(`${t('QUIT')} ?`, <CancelDialogContent />);
    else navigation(Paths.EstablishmentPage);
  }, [isDirty]);
  useEffect(() => {
    setMode(mode);
  }, [mode]);
  return (
    <>
      <TopBar
        title={t(
          mode === 'create' ? 'NEW_ESTABLISHMENT' : 'EDIT_ESTABLISHMENT',
        )}
      >
        <JButton onClick={openCancelDialog} variant="text">
          {t('CANCEL')}
        </JButton>
      </TopBar>
      <FormContainerStyled>
        <FormStepperHeader
          clickable={mode === 'edit'}
          onChangeStep={(value) => setStepIndex(value)}
          stepIndex={stepIndex}
          titles={['DETAILS', 'ADRESS', 'VIDEO']}
        />
        {stepIndex === 0 && <EstablishmentFormDetails includeFooter={true} />}
        {stepIndex === 1 && <EstablishmentFormAddress includeFooter={true} />}
        {stepIndex === 2 && <EstablishmentFormVideo includeFooter={true} />}
      </FormContainerStyled>
    </>
  );
};

const CancelDialogContent = () => {
  const { closeJDialog } = useJDialog();
  const navigation = useNavigate();
  const { t } = useTranslation();
  return (
    <Stack gap={2}>
      <Typography>{t('ESTABLISHMENT_CANCEL_TEXT')}</Typography>

      <Stack direction={'row'} gap={1}>
        <JButton
          onClick={() => {
            navigation(Paths.EstablishmentPage);
            closeJDialog();
          }}
          variant="contained"
          color="error"
        >
          {t('QUIT')}
        </JButton>
        <JButton onClick={closeJDialog} variant="contained" color="info">
          {t('CANCEL')}
        </JButton>
      </Stack>
    </Stack>
  );
};

export default EstablishmentForm;
